import type { FC } from 'react';
import { PiChatCircle } from 'react-icons/pi';
import {
  FunnelInteractionDirection,
  FunnelInteractionType,
} from 'src/api/generated';
import type { LegacyInteractionIndicatorsProps } from 'src/modules/communications/types/legacy-conversation-card.type';
import { StyledIcon } from 'src/modules/shared/components/atoms/icons/styled-icon';
import { CallStatusIndicator } from 'src/modules/shared/components/atoms/indicators/call-status-indicator';
import { DirectionIndicator } from 'src/modules/shared/components/atoms/indicators/direction-indicator';

/** Preserves the legacy interaction's direction and call/message indicators. */
export const LegacyInteractionIndicators: FC<
  LegacyInteractionIndicatorsProps
> = ({ interaction }) => {
  const isCall = interaction.modelType === FunnelInteractionType.CALL;
  return (
    <>
      <DirectionIndicator
        isOutbound={
          interaction.direction === FunnelInteractionDirection.OUTGOING
        }
        variant={isCall ? 'call' : 'whatsapp'}
      />
      {isCall ? (
        <CallStatusIndicator status={interaction.status} size="sm" />
      ) : (
        <StyledIcon
          icon={<PiChatCircle className="w-4 h-4" />}
          variant="secondary"
          size="sm"
        />
      )}
    </>
  );
};
